import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IMAGES } from "../data/content";

export default function LegalPage({ doc }) {
  return (
    <div data-testid={`legal-page-${doc.slug}`} className="grain-overlay min-h-screen bg-cream">
      <header className="relative z-10 border-b border-gold-border bg-creamalt">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-5 sm:px-6">
          <div className="flex items-center gap-3">
            <img
              src={IMAGES.logo}
              alt="Logo Ministério AURA"
              className="h-10 w-10 rounded-full object-cover"
            />
            <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
              Ministério AURA
            </span>
          </div>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 rounded-full border border-gold-border px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-mutedink transition-colors duration-300 hover:bg-teal hover:text-white"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Voltar
          </Link>
        </div>
      </header>

      <main className="relative z-10 mx-auto max-w-3xl px-5 py-12 sm:px-6 sm:py-16">
        <h1
          data-testid="legal-title"
          className="font-serif text-3xl leading-tight text-ink sm:text-4xl"
        >
          {doc.title}
        </h1>
        <p data-testid="legal-updated" className="mt-3 text-xs uppercase tracking-[0.2em] text-mutedink">
          Última atualização: {doc.updated}
        </p>

        {doc.intro && (
          <p className="mt-8 text-sm leading-relaxed text-ink sm:text-base">{doc.intro}</p>
        )}

        <div className="mt-10 space-y-10">
          {doc.sections.map((section, i) => (
            <section key={i} data-testid={`legal-section-${i + 1}`}>
              <h2 className="font-serif text-xl text-teal sm:text-2xl">{section.heading}</h2>
              <div className="mt-4 space-y-3">
                {(section.body || []).map((p, j) => (
                  <div key={j}>
                    <p className="text-sm leading-relaxed text-mutedink sm:text-base">{p}</p>
                    {section.list && section.listAfter === j && (
                      <ul className="mt-3 list-disc space-y-1.5 pl-6 text-sm leading-relaxed text-mutedink sm:text-base">
                        {section.list.map((item, k) => (
                          <li key={k}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
                {section.list && section.listAfter == null && (
                  <ul className="list-disc space-y-1.5 pl-6 text-sm leading-relaxed text-mutedink sm:text-base">
                    {section.list.map((item, k) => (
                      <li key={k}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 border-t border-gold-border pt-8 text-center">
          <Link
            to="/"
            className="text-xs font-semibold uppercase tracking-[0.2em] text-teal transition-colors duration-300 hover:text-teal-hover"
          >
            Voltar para a Landing Page
          </Link>
          <p className="mt-6 text-xs text-mutedink">
            © 2026 Ministério AURA. Todos os direitos reservados.
          </p>
        </div>
      </main>
    </div>
  );
}
